var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_shiftTypeMapping_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-staff-shift-config"),
      filterable: "",
    },
    on: {
      new: function ($event) {
        _vm.showNewMapping = true
      },
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  if (prop == "department") {
                    _vm.curDept = value
                  } //触发岗位更新下拉
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                "filter-page-data": _vm.filterPageData,
                totalCount: _vm.totalCount,
                overLoading: "",
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.shift",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap flex-row align-end" },
                        [
                          _vm._l(item.shift_type, function (shift, index) {
                            return [
                              index < 10
                                ? _c("StatusChip", {
                                    key: "shift_types---" + index,
                                    attrs: {
                                      icon: "",
                                      "content-class": " mx-1 my-1 ",
                                      "show-icon": false,
                                      bgColor: "rgba(155, 153, 153, 0.3)",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "status",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      shift.shift_type_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              index == 10
                                ? _c(
                                    "span",
                                    {
                                      key: "shift_types---" + index,
                                      staticClass: "text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        "...+" +
                                          _vm._s(item.shift_type.length - 10)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "item.staff",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "300px" } },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "pa-0",
                              attrs: { dense: "", "two-line": "" },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                {
                                  staticClass: "mr-1 my-0 pa-0",
                                  attrs: { size: "36" },
                                },
                                [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      src: item.staff.staff_avatar,
                                      staff_name: item.staff.preferred_name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass: "table-title text--primary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.staff.preferred_name
                                          )
                                        ) + " "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text--secondary text-caption-xs",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.staff.staff_code)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass:
                                        "table-subtitle text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.staff.job_post_name
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.staff_uuid,
                          delBtn: _vm.hasBtn("delete-admin-staff-shift-config"),
                          viewBtn: _vm.hasBtn("view-admin-staff-shift-config"),
                          editText:
                            "message_essweb_list_components_tools_editBtnTip",
                          editBtn: _vm.hasBtn("edit-admin-staff-shift-config"),
                          title: _vm.$t(
                            "label_essweb_eventPropertyGroup_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          view: function (uuid) {
                            _vm.viewProperty = true
                            _vm.toEdit(uuid)
                          },
                          edit: function (uuid) {
                            _vm.viewProperty = false
                            _vm.toEdit(uuid)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newShiftTypeMapping", {
              attrs: { show: _vm.showNewMapping },
              on: {
                close: function ($event) {
                  _vm.showNewMapping = false
                },
                onNew: _vm.onNew,
              },
            }),
            _c("editShiftTypeMapping", {
              attrs: {
                show: _vm.showEditMapping,
                view: _vm.viewProperty,
                curUuid: _vm.curUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showEditMapping = false
                  _vm.curUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }